<template>
    <div>
        <Header overlap="large" />

        <MainLayout margin-top>
            <Paper slot="center" padding no-header-padding>
                <div class="vfair-data">
                    <img src="../../../assets/img/vcf/vfairseriesheader.png" class="w-100 mb-5" />
                    <div v-if="!loading()">
                        <div v-html="data().body">
                            {{ data().body }}
                        </div>
                    </div>
                    <div v-else>
                        <PresentationSkeleton />
                    </div>
                </div>
            </Paper>
            <Countdown slot="right" :timestamp="startTimeStamp"></Countdown>
            <Paper slot="right">
                <div class="card p-1" style="width: 100%;">
                    <div class="card-body">
                        <h5 class="card-title">{{ data().title }}</h5>
                        <h6 class="caption text-small mb-3 gray-color">
                            <DateRange :start="data().start" :end="data().end"></DateRange>
                        </h6>
                        <OngoingBadge
                            :start="data().start"
                            :end="data().end"
                            class=""
                        ></OngoingBadge>
                    </div>
                    <div class="p-4">
                        <div v-if="shouldShowBtn()" class="mb-3">
                            <Spinner v-if="isLoadingInterested" size="sm" />
                            <div v-else>
                                <BaseButton
                                    v-if="!interested"
                                    class="d-flex align-items-center justify-content-center w-100 mb-3"
                                    :class="{
                                        disabled: isLoadingInterested,
                                    }"
                                    variant="success"
                                    @click="handleInterestedClick"
                                >
                                    {{
                                        interested
                                            ? $t('vfair.notinterested')
                                            : $t('vfair.interested')
                                    }}
                                </BaseButton>
                                <div v-else>
                                    <div class="interested d-flex">
                                        <BaseIcon class="check mr-2" name="check"></BaseIcon>
                                        {{ $t('vfair.showninterest') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <router-link to="/vfairs" class="btn btn-outline-dark w-100"
                            >Back to calendar</router-link
                        >
                    </div>
                </div>
            </Paper>
            <Resource
                slot="right"
                title="How to succeed at a virtual career fair"
                :img="masterClassImage"
                :link="'/resources?wchannelid=jdcts51v2e&wvideoid=3auxjfrbb2'"
                :inSameWindow="true"
                :header="$t('vfair.links.detailsmasterclass.header')"
            ></Resource>
        </MainLayout>
    </div>
</template>

<script>
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';

import Resource from '~/components/smart/Resource';
import PresentationSkeleton from '../../../components/skeletons/PresentationSkeleton';
import Countdown from '../list/components/Countdown';
import DateRange from '../components/DateRange';
import OngoingBadge from '../components/OngoingBadge';
import MasterClassImage from '../../../assets/img/vcf/masterclassSucceed.png';

export default {
    name: 'VFairDetails',
    components: {
        PresentationSkeleton,
        Header,
        MainLayout,
        Resource,
        Countdown,
        DateRange,
        OngoingBadge,
    },
    data() {
        return {
            interested: null,
            isLoadingInterested: false,
            masterClassImage: MasterClassImage,
        };
    },
    computed: {
        vfair() {
            return this.$interfaces.vfair.id(this.$route.params.id).get({
                reactive: true,
            });
        },
        isAuthenticated() {
            return this.$interfaces.logInModule.isLoggedIn();
        },
        startTimeStamp() {
            return new Date(this.vfair.data.start);
        },
    },
    methods: {
        getHistoryLength() {
            return window.history.length;
        },
        handleGoBackClick() {
            window.history.back();
        },
        data() {
            return this.vfair.data;
        },
        loading() {
            return this.vfair.loading;
        },
        handleInterestedClick() {
            if (!this.isAuthenticated) {
                this.$interfaces.logInModule.requireLogIn(this.$route.path);
                return;
            }

            this.isLoadingInterested = true;
            let handlerPromise = null;
            if (this.interested) {
                handlerPromise = this.$interfaces.vfairuser.user.me
                    .vfair_id(this.$route.params.id)
                    .post({ body: { interested: false } })
                    .then(() => {
                        this.interested = null;
                    });
            } else {
                handlerPromise = this.$interfaces.vfairuser.user.me
                    .vfair_id(this.$route.params.id)
                    .post({ body: { interested: true } })
                    .then(() => {
                        this.interested = true;
                    });
            }

            handlerPromise.finally(() => {
                this.$interfaces.vfairuser.user.me
                    .get({
                        forceUpdate: true,
                    })
                    .then(() => {
                        this.isLoadingInterested = false;
                    });
            });
        },
        fetchVFairUserData() {
            this.isLoadingInterested = true;
            this.$interfaces.vfairuser.user.me
                .vfair_id(this.$route.params.id)
                .get({
                    forceUpdate: true,
                })
                .then(data => {
                    if (data && data.data && data.data.id) {
                        this.interested = data.data.interested;
                    }
                })
                .catch(console.log)
                .finally(() => (this.isLoadingInterested = false));
        },
        shouldShowBtn() {
            if (this.loading()) return false;
            let check = this.data().start;
            if (!this.data().oneDayEvent) check = this.data().end;
            let now = new Date();
            let then = new Date(check);
            let nowIsThen =
                then.getDate() === now.getDate() &&
                then.getMonth() === now.getMonth() &&
                then.getFullYear() === now.getFullYear();
            return !nowIsThen && now < then;
        },
    },
    mounted() {
        if (this.isAuthenticated) {
            this.fetchVFairUserData();
        }
    },
};
</script>

<style scoped>
.vfair-data {
    padding: 15px;
}

.interested {
    color: var(--primary);
}
</style>
